import { ProgressSpinner } from 'az-platform-ui'

export const Loader =({type, text, size= 50, className }) => {
    let cssClass = '';
    if( type === 'full') {
        cssClass += 'flex flex-column  w-screen h-screen justify-content-center align-content-center align-items-center'
    }
    if( type ==='inline') {
        cssClass ='flex flex-row w-max align-items-center'
    }
    return (
        <div className={ cssClass} >
            <ProgressSpinner  style={{width: `${size}px`, height: `${size}px`}} strokeWidth="3" />
            {text && <div className={`font-italic ${className}`}>{text}</div>}
        </div>
   )
}